import { PlayerIMA } from "./player_ima";
import { PlayerEnvironment } from "./player_environment";
import Overlay from './advertisements/overlay';
import InstreamAdvertisement from "./components/instream_advertisement";
import PauseAdvertisement from "./components/pause_advertisement";
import IasAdapter from "./adapters/ias_adapter";
import UUIDManager from "./uuid_manager";
import SqueezeFrame from "./advertisements/squeeze_frame";
import AdState from "./advertisements/ad_state";

export class PlayerAdvertisement {
  constructor(tech, data, params){
    this._tech = tech;
    this._uuidManager = new UUIDManager();
    this._ima = new PlayerIMA(tech, data, this._uuidManager, params);
    this._currentAdType = null;
    this._currentAdTag = null;
    this._data = data;
    this._instreamAd = null;
    this.adState = new AdState();
    this._pauseAd = new PauseAdvertisement({ tech, data, adState: this.adState });

    this._params = params;

    this._overlay = new Overlay({ tech, data, adState: this.adState });
    this._squeezeFrame = new SqueezeFrame({ tech, data, adState: this.adState });
    this._iasAdapter = new IasAdapter(this.tech());
  }

  tech(){
    return this._tech;
  }

  uuidManager(){
    return this._uuidManager;
  }

  params(){
    return this._params;
  }

  ima(){
    return this._ima;
  }

  overlay() {
    return this._overlay;
  }

  squeezeFrame() {
    return this._squeezeFrame;
  }

  instreamAdvertisement() {
    return this._instreamAd;
  }

  pauseAdvertisement() {
    return this._pauseAd;
  }

  currentAdTag() {
    return this._currentAdTag;
  }

  setCurrentAdTag(tag) {
    this._currentAdTag = tag;
  }

  adPlaylistId() {
    return this.instreamAdvertisement().adPlaylistId();
  }

  iasAdapter() {
    return this._iasAdapter;
  }

  setCurrentAdType(type) {
    this._currentAdType = type;
  }

  isAdsBlacklisted() {
    let blocked = false;
    let referrer = this.data().getDocumentReferrer();

    this.data().adsBlacklist().forEach(item => {
      if(referrer.includes(item)) blocked = true;
    });

    return blocked;
  }

  shouldInitPlayerAdvertisement() {
    return (
      window.google !== undefined &&
      !this.isAdsBlacklisted() &&
      PlayerEnvironment.isPrerollAdsEnabled()
    )
  }

  initPlayerAdvertisements(){
    if (this.shouldInitPlayerAdvertisement()) {
      this.bindAdsManagerEvent();
      this.bindAdsRequestEvent();
      this.initVideoAds();
      this.initAdsCountdown();
    }
  }

  initAdsCountdown() {
    if (this.ima().imaOptions().autoPlayAdBreaks) {
      this.ima().adsCountdown().init();
    }
  }

  bindAdsManagerEvent() {
    this.tech().on('ads-manager', function(manager){
      this.iasAdapter().setup(manager.adsManager);
    }.bind(this));
  }

  bindAdsRequestEvent() {
    this.tech().on('ads-request', () => {
      this.sendAdsRequestEvent();
    });
  }

  sendAdsRequestEvent() {
    this.tech().trigger({
      type: 'ads-request-loaded',
      videoId: this.data().videoId(),
      currentAdTag: this.currentAdTag(),
      premier: this.data().isPremier(),
      playUUID: this.data().playUUID(),
      contentType: this.data().type(),
      adPlaylistId: this.adPlaylistId(),
      adTagIsVmap: this.instreamAdvertisement().params().adTagIsVmap()
    });
  }

  initVideoAds() {
    this.constructInstreamAd();
    this.instreamAdvertisement().init();
    this.bindPlayAfterAd();
    this.setCurrentAdTag(this.instreamAdvertisement().params().prerollTag());
  }

  constructInstreamAd() {
    this._instreamAd = new InstreamAdvertisement({ tech: this.tech(), params: this.params(), ima: this.ima(), data: this.data() });
  }

  bindPlayAfterAd() {
    this.tech().on('adend', () => {
      this.tech().play();
    });
  }

  initPauseAdvertisement() {
    if (PauseAdvertisement.shouldInit({ data: this.data() })) {
      this.pauseAdvertisement().init();
    }
  }

  paramsPresent(){
    if(this.params() == undefined) return false;

    return this.params().present();
  }

  imaAdTitle(){
    return this.ima().adTitle();
  }

  imaAdDuration(){
    return this.ima().currentAdDuration();
  }

  imaAdSkippable(){
    return this.ima().adSkippable();
  }

  skip(){
    this.ima().skip();
  }

  currentTime(){
    return this.ima().adCurrentTime();
  }

  uuid(){
    return this.uuidManager().uuid();
  }

  bindStartAdOverlay() {
    this.tech().one('playing', function(){
      setTimeout(() => {
        this.overlay().start();
      }, this.overlay().firstRenderTime());
    }.bind(this));
  }

  bindStartSqueezeFrameAd() {
    if (!SqueezeFrame.shouldStart({ data: this.data() })) {
      return;
    }

    this.tech().one('playing', function(){
      setTimeout(() => {
        this.squeezeFrame().start();
      }, this.squeezeFrame().firstRenderTime());
    }.bind(this));
  }

  videoElement() {
    return this.tech().videoElement();
  }

  currentAdType(){
    return this.instreamAdvertisement().currentAdType();
  }

  clearUUID(){
    this.uuidManager().clear()
  }

  data() {
    return this._data
  }
}
